import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling
import { Link } from 'react-router-dom'; // Import Link from react-router-dom

import KSAVRF from '../assets/images/KSA-VRF.png';



function KSAVRF14() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('KSA_VRF')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          <p style={{ textAlign: 'justify' }}>{t('KSA_VRF_def')}</p>
          <p style={{ textAlign: 'justify' }}>{t('KSA_VRF_sub1')}</p>
          <table className='table-container'>
        
        <tbody>
          <tr>
            <td ><b>{t('KSA_VRF_table_l1')}</b></td>
            <td >{t('KSA_VRF_table_l1_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l2')}</b></td>
            <td >{t('KSA_VRF_table_l2_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l3')}</b></td>
            <td >{t('KSA_VRF_table_l3_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l4')}</b></td>
            <td >{t('KSA_VRF_table_l4_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l5')}</b></td>
            <td >{t('KSA_VRF_table_l5_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l6')}</b></td>
            <td >{t('KSA_VRF_table_l6_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l7')}</b></td>
            <td >{t('KSA_VRF_table_l7_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l8')}</b></td>
            <td >{t('KSA_VRF_table_l8_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l9')}</b></td>
            <td >{t('KSA_VRF_table_l9_value')}</td>
          </tr>
          <tr>
            <td ><b>{t('KSA_VRF_table_l10')}</b></td>
            <td >{t('KSA_VRF_table_l10_value')}</td>
          </tr>
          
        </tbody>
      </table>
          <p style={{ textAlign: 'justify' }}>{t('KSA_VRF_sub2')}
            <a href={t('SANSRS_Implementation_Guide_URL')} download> 
                  {t('sansrs_def1_sub5_link')}
                </a>
            
           </p>
          
          <img src={KSAVRF} alt="Arrow Icon" style={{ width: '100%', height: 'auto', maxWidth: '600px' }} /></div>
          <br />          
          
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    <section class="services"style={{gap:"6rem", padding:"1rem"}}>
    <p style={{ textAlign: 'justify' }}>{t('tools')}<Link to="https://gds.geoportal.sa/vrf" target='balnk'>{t('onlineheightTT')}</Link><br></br><br></br><Link to="/Geodesy/Sansrs/KSAVRF14/FAQ">{t('faq_title')}</Link></p>
      
    </section>
    </div>
);
}

export default KSAVRF14;
